module.exports = __webpack_public_path__ + "img/collection-weddingRingsMillgrif@2x.7a85395.jpg";